import React,  { useState } from 'react';
import Select, { components } from 'react-select';

const MultiValue = ({ data, children, ...props }) => {
  return null; // Don't render individual tags
};

const Control = ({ children, ...props }) => {
  const { getValue } = props;
  const value = getValue();
  const count = value ? value.length : 0;

  return (
	<components.Control {...props}>
	  {count > 0 ? <span className="territory-header-countries-selected">{count} option{count>1?'s':''} selected</span> : ''}
	  {children}
	</components.Control>
  );
};

export default function MultiSelect(props) {
	return <Select
		components={{
			MultiValue,
			Control,
		}}
		closeMenuOnSelect={false}
		hideSelectedOptions={false}
		{...props}
	/>
}